import { render, staticRenderFns } from "./CloudClassroomProject.vue?vue&type=template&id=2d543ea3&scoped=true&"
import script from "./CloudClassroomProject.vue?vue&type=script&lang=js&"
export * from "./CloudClassroomProject.vue?vue&type=script&lang=js&"
import style0 from "./CloudClassroomProject.vue?vue&type=style&index=0&id=2d543ea3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d543ea3",
  null
  
)

export default component.exports